// ** Next Import
import React from 'react';

// ** MUI Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { GridRowId } from '@mui/x-data-grid'
import MenuItem from '@mui/material/MenuItem'
import CanvaDesignModal from '../../../../components/DesignWithModal';
import axios from '../../../../services/ApiService'
import { AxiosError } from "axios";
import DisconnectProviderButton from '../../../../components/DisconnectButton';

interface TableHeaderProps {
    value: string
    selectedRows: GridRowId[]
    handleFilter: (val: string) => void
    handleClickAddChannel: () => void
    setShowPostContentDialog: (arg0: boolean) => void
    isDefaultOrgActive : boolean
}

interface CanvaDesign {
    id: string;
    title: string;
    thumbnailUrl: string;
    editUrl?: string;
    viewUrl?: string;
}

const TableHeader = (props: TableHeaderProps) => {
    // ** Props
    const { selectedRows, handleClickAddChannel, setShowPostContentDialog, isDefaultOrgActive } = props

    const [showCanvaModal, setShowCanvaModal] = React.useState(false);
    const [canvaDesigns, setCanvaDesigns] = React.useState<CanvaDesign[]>([]);
    const [loadingDesigns, setLoadingDesigns] = React.useState(false);

    React.useEffect(() => {
        if (showCanvaModal) {
            setLoadingDesigns(true);
            axios.get('/channel/listDesigns')
                .then(res => {
                    console.log("Raw /channel/listDesigns response:", res.data);

                    const items = Array.isArray(res.data) ? res.data : res.data.items || [];
                    const mappedDesigns = items.map((design: any): CanvaDesign => ({
                        id: design.id,
                        title: design.title || "Untitled",
                        thumbnailUrl: design.thumbnailUrl,
                        editUrl: design.editUrl || design.editurl || design.edit_url,
                        viewUrl: design.viewUrl || design.viewurl || design.view_url,
                        /*... */
                    }));
                    setCanvaDesigns(mappedDesigns);
                })
                .catch(err => {
                    setCanvaDesigns([]);
                    console.log("There was an error", err);

                })
                .finally(() => setLoadingDesigns(false));
        }
        console.log("Canva designs: ", canvaDesigns);
    }, [showCanvaModal]);

    async function handleDesignTypeSelected(type: string) {
        // 🚩 Open a blank tab immediately, synchronously!
        const newTab = window.open("about:blank", "_blank");
        if (!newTab) {
            alert("Please enable popups for this site!");
            return;
        }

        try {
            const payload = { DesignType: type };
            const response = await axios.post("/channel/CreateOrFetchCanvaDesign", payload, {
                withCredentials: true
            });

            const data = response.data;
            if (data.designUrl) {
                newTab.location = data.designUrl;
            } else {
                newTab.close();
                alert("No design URL returned. Check your backend logs for more info.");
            }
        } catch (err) {
            newTab.close();
            alert("Failed to create/fetch Canva design.");
        }
    }

    return (
        <Box
            sx={{
                p: 5,
                pb: 3,
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'flex-end'
            }}
        >
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Button
                    variant='outlined'
                    color='secondary'
                    onClick={() => setShowPostContentDialog(true)}
                    sx={{ mb: 2, mr: 2 }}
                >
                    Add Post
                </Button>
                <Button
                    variant='outlined'
                    color='secondary'
                    onClick={() => setShowCanvaModal(true)}
                    sx={{ mb: 2, mr: 2 }}
                >
                    Design Post
                </Button>
                {isDefaultOrgActive && <Button sx={{ mb: 2 }} variant='contained' onClick={handleClickAddChannel}>
                    Add Channel
                </Button>
                }
                {/*<DisconnectProviderButton provider="reddit"  />*/}

                <CanvaDesignModal
                    open={showCanvaModal}
                    onClose={() => setShowCanvaModal(false)}
                    onDesignTypeSelected={handleDesignTypeSelected}
                    canvaDesigns={canvaDesigns}
                    loadingDesigns={loadingDesigns}
                />
            </Box>
        </Box>
    )
}

export default TableHeader
